export function getValue(json, key, value = '') {
  if (key) {
    for (const k of key.split('.')) {
      if (json) {
        json = json[k];
      }
      else {
        break;
      }
    }
  }
  return json ? json : value;
}

export function getItemValue(json, keys = [], value = '') {
  for (const key of keys) {
    if (json) {
      json = json[key];
    } else {
      break;
    }
  }
  return json ? json : value;
}

export function getDateTime(json, key, value = '', prefix = '', suffix = '') {
  const date = new Date(getValue(json, key, value));
  if (Date.parse(date)) {
    return `${prefix}${date.toLocaleString("pt-BR")}${suffix}`;
  }
  return value;
}

export function getDate(json, key, value = '', prefix = '', suffix = '') {
  const date = new Date(getValue(json, key, value));
  if (Date.parse(date)) {
    return `${prefix}${date.toLocaleDateString("pt-BR")}${suffix}`;
  }
  return value;
}

export function getTime(json, key, value = '', prefix = '', suffix = '') {
  const date = new Date(getValue(json, key, value));
  if (Date.parse(date)) {
    return `${prefix}${date.toLocaleTimeString("pt-BR")}${suffix}`;
  }
  return value;
}

/*
export function getDateTime(json, key, value = '', prefix = '', suffix = '') {
  return `${prefix}${new Date(getValue(json, key, value)).toLocaleString("pt-BR")}${suffix}`;
}

export function getDate(json, key, value = '', prefix = '', suffix = '') {
  return `${prefix}${new Date(getDateTime(json, key, value)).toLocaleDateString("pt-BR")}${suffix}`;
}

export function getTime(json, key, value = '', prefix = '', suffix = '') {
  return `${prefix}${new Date(getDateTime(json, key, value)).toLocaleTimeString("pt-BR")}${suffix}`;
}
*/

export function formatMoney(value = 0, sign = '', currency = 'B$', digits = 2) {
  return `${sign}${currency} ${Number(value).toLocaleString('pt-BR', { minimumFractionDigits: digits })}`;
}

export function getMoney(json, keys = [], value = 0, sign = undefined, currency = undefined, digits = undefined) {
  return formatMoney(getItemValue(json, keys, value), sign, currency, digits);
}

export function getMonthYear(dateStr) {
  const monthNames = [ "Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez" ];
  return `${new Date(dateStr).getDate()} ${monthNames[new Date(dateStr).getMonth()]} / ${new Date(dateStr).getFullYear().toString().slice(-2)}`;
}